import { render, staticRenderFns } from "./Outbound.vue?vue&type=template&id=242e21e7&scoped=true"
import script from "./Outbound.vue?vue&type=script&lang=js"
export * from "./Outbound.vue?vue&type=script&lang=js"
import style0 from "./Outbound.vue?vue&type=style&index=0&id=242e21e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e21e7",
  null
  
)

export default component.exports